<template>
<section id="market-index mt-3">
	<h1>Markets</h1>

	<div class="card animate__animated animate__fadeIn">
		<div class="card-body">
			<table class="table table-borderless">
				<thead>
				<tr>
					<th>Address</th>
					<th>Base Mint</th>
					<th>Quote Mint</th>
					<th>Quote Lot Size</th>
					<th>Base Lot Size</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(mkt,key) in markets" :key="key">
					<td>
						<AccountAddress :address="mkt.ownAddress"></AccountAddress>
					</td>
					<td>
						<AccountAddress :address="mkt.baseMint"></AccountAddress>
					</td>
					<td>
						<AccountAddress :address="mkt.quoteMint"></AccountAddress>
					</td>
					<td>{{mkt.quoteLotSize}}</td>
					<td>{{mkt.baseLotSize}}</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</section>
</template>

<script>
import Openbook from "@/api/openbook";
import AccountAddress from "@/components/common/AccountAddress.vue";

export default {
	name: "MarketIndex",
	components: {AccountAddress},
	data() {
		return {
			markets: [],
			openbook: new Openbook(this.$store.state.solana.client)
		}
	},
	beforeMount() {
		this.openbook.getMarkets().then(r => {
			this.markets = r
		})
	}
}
</script>

<style scoped>

</style>